import React from 'react';
import '../CSS/AI&ML.css';

const AIML: React.FC = () => {
  return (
    <div className="ai-ml-page">
      <div className="ai_ml_hero">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h1 className="banner-title">Artificial Intelligence And ML</h1>
        </div>
      </div>

      <div className="ai_ml_facts">
        <div className="ai-ml-facts-content">
          <div className="ai-ml-facts-description">
            <p>Embark on your AI journey with Zemantics' comprehensive AI development services. We offer end-to-end development, from conceptualizing and crafting AI solutions to seamlessly integrating them within your existing infrastructure.</p>
          </div>
          
          <div className="ai-ml-facts-cards">
            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/enterprise-solutions-icon.svg" alt="AI Development Services" />
              </div>
              <h3 className="card-title">Leverage Our AI Development Services To Create Next-Generation Enterprise Solutions</h3>
              <p className="card-description">Enhance your business performance with our data-driven AI solutions crafted leveraging advanced AI technologies like deep learning, machine learning, computer vision and natural language processing.</p>
            </div>

            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/ai-ml-icon.svg" alt="AI/ML Strategy Consulting" />
              </div>
              <h3 className="card-title">AI/ML Strategy Consulting</h3>
              <p className="card-description">Trust the expertise and deep tech background of the best minds at Zemantics to steer you through the complexities of AI implementation through effective development approaches and strategic advice. We are committed to maximizing the value of AI/ML for your business, ensuring sustainable growth in this transformative landscape.</p>
            </div>

            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/poc-icon.svg" alt="PoC And MVP Development" />
              </div>
              <h3 className="card-title">PoC And MVP Development</h3>
              <p className="card-description">Our team of experts meticulously crafts Proof of Concepts to validate the feasibility of your AI solution's concept, showcasing its potential through scaled-down versions. Moving forward, we design Minimum Viable Products that deliver essential functionalities, enabling real user validation, iterative development, and rapid market entry.</p>
            </div>

            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/custom-model-development-icon.svg" alt="Custom Model Development" />
              </div>
              <h3 className="card-title">Custom Model Development</h3>
              <p className="card-description">We handle the entire custom AI model development process for our clients. This encompasses meticulous data preparation, rigorous model training, multi-level testing, and seamless deployment of the model. With deep expertise in fine-tuning AI models for specific tasks and domains, we ensure the models deliver optimal performance for your unique business requirements.</p>
            </div>

            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/custom-ai-solutions-development-icon.svg" alt="Custom AI Solutions Development" />
              </div>
              <h3 className="card-title">Custom AI Solutions Development</h3>
              <p className="card-description">We collaborate with you to create AI-powered web and mobile apps that precisely align with your unique business needs. From the user interface to the algorithm, we meticulously engineer every aspect of your solution to guarantee optimal performance. Committed to both security and ethical AI, our AI development approach prioritizes responsible innovation.</p>
            </div>

            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/ai-integration-icon.svg" alt="AI Integration And Deployment" />
              </div>
              <h3 className="card-title">AI Integration And Deployment</h3>
              <p className="card-description">We go beyond crafting robust AI solutions by seamlessly integrating and deploying them into your existing infrastructure, empowering your business with AI capabilities that align with your established processes. With AI embedded into your operational framework, you witness remarkable gains in efficiency, productivity, and innovation.</p>
            </div>

            <div className="ai-ml-facts-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/data-analysis-icon.svg" alt="Data Analysis And Visualization" />
              </div>
              <h3 className="card-title">Data Analysis And Visualization</h3>
              <p className="card-description">Leverage the expertise of Zemantics' data analytics experts to drive business growth through data-driven decisions. With their extensive proficiency in statistics, programming, data visualization, and machine learning, our data analysts enable businesses to derive essential insights from their data, enhance data strategies, and grasp complex data intricacies.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="ai_image_divider">
        <img src="/Assets/Services/AI & ML/ai-ml-section-image.png" alt="AI & ML Section Divider" />
      </div>

      <div className="ai_expertise">
        <div className="ai-expertise-content">
          <h2 className="ai-expertise-title">Why Choose Zemantics?</h2>
          
          <div className="ai-expertise-cards">
            <div className="ai-expertise-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/expert-ai-icon.svg" alt="Expert AI Professionals" />
              </div>
              <h3 className="card-title">Expert AI Professionals</h3>
              <p className="card-description">Zemantics boasts a team of skilled professionals with expertise in advanced AI technologies such as machine learning, natural language processing, and computer vision. With a proven track record of successful implementations, our experts craft tailored solutions across diverse domains.</p>
            </div>

            <div className="ai-expertise-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/extensive-experience-ai-icon.svg" alt="Extensive Experience In AI" />
              </div>
              <h3 className="card-title">Extensive Experience In AI</h3>
              <p className="card-description">With a wealth of experience in AI development, Zemantics is your trusted technology partner. Our track record showcases a diverse array of successfully built AI solutions underpinned by a profound knowledge of AI technologies. From recommendation systems to chatbots, our expertise spans a wide spectrum.</p>
            </div>

            <div className="ai-expertise-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/security-icon.svg" alt="We Prioritize Security" />
              </div>
              <h3 className="card-title">We Prioritize Security</h3>
              <p className="card-description">As we build and implement your AI projects, we prioritize security at every step. Our team meticulously follows industry-leading practices to ensure your data, algorithms, and AI systems are fortified against potential threats, and you can innovate with confidence, knowing your AI solutions are protected.</p>
            </div>

            <div className="ai-expertise-card">
              <div className="card-icon">
                <img src="/Assets/Services/AI & ML/ai-development-icon.svg" alt="End-To-End AI Development" />
              </div>
              <h3 className="card-title">End-To-End AI Development</h3>
              <p className="card-description">We begin with an in-depth consultation to understand your goals and requirements, develop an AI solution and tailor it to your specific needs, and then rigorously test and refine it to perfection. We then seamlessly integrate it into your existing systems, ensuring a smooth transition and maximizing the benefits of AI across your operations.</p>
            </div>
          </div>
        </div>
      </div>

      <div className="ai_ml_expertise">
        <div className="ai-ml-expertise-content">
          <h2 className="ai-ml-expertise-title">Technologies We Have Expertise In</h2>
          
          <div className="ai-ml-expertise-grid">
            <div className="ai-ml-expertise-bottom-card">
              <div className="expertise-card-icon">
                <img src="/Assets/Services/Data Engineering/machine-learning-icon.svg" alt="Machine Learning" />
              </div>
              <div className="expertise-card-content">
                <h3 className="expertise-bottom-title">Machine Learning</h3>
                <p className="expertise-card-description">Our team of machine learning experts helps clients extract valuable insights from unstructured data from multiple resources, enabling them to drive business growth and expand their businesses.</p>
              </div>
            </div>

            <div className="ai-ml-expertise-bottom-card">
              <div className="expertise-card-icon">
                <img src="/Assets/Services/Data Engineering/deep-learning-icon.svg" alt="Deep Learning" />
              </div>
              <div className="expertise-card-content">
                <h3 className="expertise-bottom-title">Deep Learning</h3>
                <p className="expertise-card-description">We implement Deep learning-based solutions for advanced speech and facial recognition, automation, and business intelligence.</p>
              </div>
            </div>

            <div className="ai-ml-expertise-bottom-card">
              <div className="expertise-card-icon">
                <img src="/Assets/Services/AI & ML/predictive-analytics-icon.svg" alt="Predictive Analytics" />
              </div>
              <div className="expertise-card-content">
                <h3 className="expertise-bottom-title">Predictive Analytics</h3>
                <p className="expertise-card-description">Our data-driven and machine learning-based predictive analytics help your business by providing insight into future trends.</p>
              </div>
            </div>

            <div className="ai-ml-expertise-card">
              <div className="expertise-card-icon">
                <img src="/Assets/Services/Data Engineering/nlp-icon.svg" alt="Natural Language Processing" />
              </div>
              <div className="expertise-card-content">
                <h3 className="expertise-bottom-title">Natural Language Processing</h3>
                <p className="expertise-card-description">Our team's deep understanding of NLP algorithms, techniques, and models allows us to unlock the potential of textual data.</p>
              </div>
            </div>
            <div className="ai-ml-expertise-bottom-card">
              <div className="expertise-card-icon">
                <img src="/Assets/Services/AI & ML/data-science-icon.svg" alt="Data Science" />
              </div>
              <div className="expertise-card-content">
                <h3 className="expertise-bottom-title">Data Science</h3>
                 <p className="expertise-bottom-description">Our data scientists specialize in data science development services and excel at providing predictive analytics and advanced AI techniques for specific business use cases.</p>
              </div>
            </div>

            <div className="ai-ml-expertise-bottom-card">
              <div className="expertise-card-icon">
                <img src="/Assets/Services/AI & ML/data-capture-icon.svg" alt="Data Capture / OCR" />
              </div>
              <div className="expertise-card-content">
                <h3 className="expertise-bottom-title">Data Capture / OCR</h3>
                <p className="expertise-bottom-description">Our advanced data capture and extraction automation technique simplifies document processing, leading to improved accuracy, increased efficiency, and reduced human error for businesses.</p>
              </div>
            </div>
          </div>

          <div className="ai-ml-expertise-bottom">
            <div className="expertise-stack-icon">
              <img src="/Assets/Services/Data Engineering/ai-technology-stack-icon.svg" alt="AI Technology Stack" />
            </div>
            <div className="ai-ml-expertise-stack">
              <h3 className="expertise-stack-title">AI Technology Stack</h3>
              <div className="expertise-stack-content">
                <div className="stack-section">
                  <h4 className="stack-section-title">Generative AI Models:</h4>
                  <p className="stack-section-content">Generative Adversarial Networks, Transformer models (GPT3, GPT 3.5 Turbo, LaMDA, Wu-Dao), Llama, Palm 2, GPT-4</p>
                </div>
                <div className="stack-section">
                  <h4 className="stack-section-title">Algorithms:</h4>
                  <p className="stack-section-content">Supervised/Unsupervised Learning, Clustering, Metric Learning, Fewshot Learning</p>
                </div>
                <div className="stack-section">
                  <h4 className="stack-section-title">Neural Networks:</h4>
                  <p className="stack-section-content">CNN, RNN, Representation Learning, Manifold Learning, Variational Autoencoders, Bayesian Network, Autoregressive Networks</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIML; 